import { RedesignShell } from '@/components/marketing/redesign/RedesignShell';

interface AuthPageLayoutProps {
  children: React.ReactNode;
}

/** Auth / onboarding chrome — matches marketing redesign (nav + footer). */
export function AuthPageLayout({ children }: AuthPageLayoutProps) {
  return (
    <RedesignShell>
      <section className="auth-page">
        <div className="rd-container auth-page-inner">{children}</div>
      </section>
    </RedesignShell>
  );
}
